import { render, staticRenderFns } from "./#basic.vue?vue&type=template&id=33d56c6a&"
import script from "./#basic.vue?vue&type=script&lang=js&"
export * from "./#basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports